'use client'

import { ErrorModalBase } from '@src/components/ErrorModalBase/ErrorModalBase'
import { configPublic } from '@src/config.public'
import { useErrors } from '@src/hooks/useErrors'
import { useLocalizedRouter } from '@src/hooks/useLocalizedRouter'
import { useLocale } from '@src/i18n/LocaleProvider'
import { ErrorCodes, ErrorType } from '@src/utils/constants.util'

export function ErrorModal() {
  const router = useLocalizedRouter()
  const { error, type, code } = useErrors()
  const { t } = useLocale('common')

  const shouldHide =
    !error || !type || type === ErrorType.Payment || code === ErrorCodes.InvalidQuantity

  if (shouldHide) return null

  const titles: Partial<Record<ErrorType, string>> = {
    [ErrorType.Unknown]: t('error-unknown-title'),
    [ErrorType.InvalidItems]: t('error-unknown-title'),
    [ErrorType.Identity]: t('identity-outage-title'),
    [ErrorType.Eligibility]: '',
  }

  const message: Partial<Record<ErrorType, string>> = {
    [ErrorType.Unknown]: t('error-unknown-message'),
    [ErrorType.InvalidItems]: t('error-unknown-message'),
    [ErrorType.Identity]: t('identity-outage-message'),
    [ErrorType.Eligibility]: '',
  }

  const ctaLabels: Partial<Record<ErrorType, string>> = {
    [ErrorType.Unknown]: t('error-unknown-cta'),
    [ErrorType.InvalidItems]: t('error-unknown-cta'),
    [ErrorType.Identity]: t('identity-outage-cta'),
    [ErrorType.Eligibility]: '',
  }

  const ctaTestId: Partial<Record<ErrorType, string>> = {
    [ErrorType.Unknown]: 'okayBtn',
    [ErrorType.InvalidItems]: 'okayBtn',
    [ErrorType.Identity]: 'homePageBtn',
    [ErrorType.Eligibility]: 'browseProgramsBtn',
  }

  const ctaActions: Partial<Record<ErrorType, () => any>> = {
    [ErrorType.Unknown]: () => {
      window.location.reload()
    },
    [ErrorType.InvalidItems]: () => {
      window.location.reload()
    },
    [ErrorType.Identity]: () => {
      router.push('/')
    },
    [ErrorType.Eligibility]: () => {
      router.push(configPublic.general.eligibilityRedirectUrl)
    },
  }
  return (
    <ErrorModalBase
      ctaProps={{
        'data-testid': ctaTestId[type],
      }}
      onClick={ctaActions[type]}
      ctaText={ctaLabels[type]}
      title={titles[type]}
      message={message[type]}
    />
  )
}
